import React, { useState, useEffect } from "react";
import { database } from "../../firebase";
import { ref, onValue, remove, orderByChild, startAfter, limitToLast, limitToFirst, equalTo, endBefore } from "firebase/database";
import { getFirestore, collection, query, where, orderBy, limit, startAfter as startAfterF, getDocs, getCountFromServer, doc, deleteDoc } from 'firebase/firestore';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { downloadDevolucionExcel, downloadDevolucionExcelMultiple } from '../../utils/devolucionExcel';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import SnackbarWrapper from "../../components/Snackbar/SnackBarWrapper";
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import MuiAlert from '@mui/material/Alert';
import { StyledTableCell, StyledTableRow } from '../../utils/styled'
import PrintIcon from '@mui/icons-material/Print';
import TextField from '@mui/material/TextField';
import { filesPage } from '../../utils/default'
import { CircularProgress, Pagination, Chip, Box, Tooltip } from "@mui/material";
import ModalFilters from "../../components/ModalFilters/ModalFilters";
import moment from "moment";
import { formatDate } from "../../utils/dateUtils";
import emailjs from '@emailjs/browser';
import { getCuadrillaById, getCuadrillaEmailById } from '../../services/cuadrillasService';
const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const firestore = getFirestore();

// Normaliza fecha a YYYYMMDD. El campo `fecha` en Firestore se guarda en formatos mixtos
// (DD/MM/YYYY, YYYYMMDD, ISO 2026-03-15T...), por eso hay que parsear los 3 casos para comparar rangos.
const parseFechaToYYYYMMDD = (fecha) => {
    if (!fecha) return '';
    const str = String(fecha);
    if (str.includes('-') && str.length >= 10) return str.slice(0, 10).replaceAll('-', '');
    if (str.includes('/')) return str.split('/').reverse().join('');
    return str;
};

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ListRemitos() {
    const [remitos, setRemitos] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [remitoToDelete, setRemitoToDelete] = useState(-1);
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });
    const [searchTitle, setSearchTitle] = useState('');
    const [remitoFilter, setRemitoFilter] = useState([]);
    const [pagePagination, setPagePagination] = useState(1);
    const [lastVisible, setLastVisible] = useState(null); // Para paginación
    const [pageQuantity, setPageQuantity] = useState(1);
    const [numberPage, setNumberPage] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const [openSearchModal, setOpenSearchModal] = useState(false);
    const [showPagination, setShowPagination] = useState(false);

    // Estados para el modal de email
    const [openEmailModal, setOpenEmailModal] = useState(false);
    const [selectedRemito, setSelectedRemito] = useState(null);
    const [recipientEmail, setRecipientEmail] = useState('');
    const [emailLoading, setEmailLoading] = useState(false);
    const [emailLoadingCuadrilla, setEmailLoadingCuadrilla] = useState(false);

    // Estados para el modal de descarga Excel devoluciones
    const [openDownloadModal, setOpenDownloadModal] = useState(false);
    const [downloadDateFrom, setDownloadDateFrom] = useState(null);
    const [downloadDateTo, setDownloadDateTo] = useState(null);
    const [downloadLoading, setDownloadLoading] = useState(false);

    const remitosCollection = collection(firestore, 'remitos');

    // Configuración del número de registros por página
    const recordsPerPage = 100;

    // Obtener el número de página del query param
    const params = new URLSearchParams(window.location.search);
    const pageNumber = parseInt(params.get('page')) || 1;
    // setNumberPage(pageNumber)

    const calculateStartId = (page) => (page - 1) * recordsPerPage;

    const getLastId = async () => {
        try {
            // Referencia a la colección "cuadrillas" o la colección que estés usando
            const collectionRef = collection(firestore, 'remitos');

            // Consulta para obtener el documento con el `id` más alto
            const lastIdQuery = query(collectionRef, orderBy('id', 'desc'), limit(1));
            const snapshot = await getDocs(lastIdQuery);

            if (!snapshot.empty) {
                // Obtiene el campo `id` del documento con el ID más alto
                const lastDoc = snapshot.docs[0].data();
                const totalCount = lastDoc.id; // Asumiendo que el `id` representa el total de registros
                return totalCount;
            } else {
                return 0; // No hay documentos en la colección
            }
        } catch (error) {
            console.error("Error al obtener el último ID:", error);
            return 0;
        }
    };

    const fetchTotalCount = async () => {
        // Para filtros, usamos un conteo aproximado basado en el último ID
        // En producción se podría usar getCountFromServer() con la misma lógica de filtros
        const totalCount = await getLastId();
        const pages = Math.ceil(totalCount / recordsPerPage);
        setPageQuantity(pages);
    };

    // ✅ Función de diagnóstico temporal para verificar la estructura de datos
    const diagnosticQuery = async () => {
        console.log('🔧 === DIAGNÓSTICO DE ESTRUCTURA DE DATOS REMITOS ===');
        try {
            const diagnosticQuery = query(remitosCollection, limit(3));
            const snapshot = await getDocs(diagnosticQuery);

            if (!snapshot.empty) {
                snapshot.docs.forEach((doc, index) => {
                    const data = doc.data();
                    console.log(`🔧 Remito ${index + 1}:`, {
                        documentId: doc.id,
                        allFields: Object.keys(data),
                        id: data.id,
                        idCuadrillaEntrega: {
                            valor: data.idCuadrillaEntrega,
                            tipo: typeof data.idCuadrillaEntrega
                        },
                        idCuadrillaReceptora: {
                            valor: data.idCuadrillaReceptora,
                            tipo: typeof data.idCuadrillaReceptora
                        },
                        cuadrillaEntrega: data.cuadrillaEntrega,
                        cuadrillaReceptora: data.cuadrillaReceptora,
                        fecha: data.fecha,
                        dateQuery: data.dateQuery
                    });
                });
            }
        } catch (error) {
            console.error('🔧 Error en diagnóstico:', error);
        }
        console.log('🔧 === FIN DIAGNÓSTICO REMITOS ===');
    };

    const fetchRemitos = async (page) => {
        console.log('🔍 === INICIO fetchRemitos ===');

        // Ejecutar diagnóstico solo si hay filtros aplicados
        const hasFiltersForDiagnostic = params.get('cuadrillaEntrega') || params.get('cuadrillaReceptora') || params.get('idRemito') || params.get('dateFrom');
        if (hasFiltersForDiagnostic) {
            await diagnosticQuery();
        }

        // Obtener parámetros de filtro
        const cuadrillaEntrega = params.get('cuadrillaEntrega');
        const cuadrillaReceptora = params.get('cuadrillaReceptora');
        const idRemito = params.get('idRemito');
        const dateFrom = params.get('dateFrom');
        const dateTo = params.get('dateTo');

        console.log('🔍 Parámetros de filtro:', {
            cuadrillaEntrega,
            cuadrillaReceptora,
            idRemito,
            dateFrom,
            dateTo,
            page
        });

        // Verificar si hay filtros aplicados
        const hasFilters = cuadrillaEntrega || cuadrillaReceptora || idRemito || dateFrom || dateTo;
        console.log('🔍 ¿Hay filtros aplicados?', hasFilters);

        let remitosQuery;
        let shouldPaginate = false;

        // ✅ Aplicar filtros de manera individual - más compatible con Firestore
        if (idRemito) {
            // Si busca por ID específico - no necesita paginación
            console.log('🔍 Búsqueda por ID remito específico:', idRemito);
            remitosQuery = query(
                remitosCollection,
                where('id', '==', parseInt(idRemito, 10))
            );
            shouldPaginate = false;
        } else if (cuadrillaEntrega && cuadrillaReceptora) {
            // Filtro combinado de cuadrillas - no necesita paginación
            console.log('🔍 Filtro combinado cuadrilla entrega + receptora');
            remitosQuery = query(
                remitosCollection,
                where('idCuadrillaEntrega', '==', parseInt(cuadrillaEntrega, 10)),
                where('idCuadrillaReceptora', '==', parseInt(cuadrillaReceptora, 10)),
                orderBy('id', 'desc'),
                limit(recordsPerPage * 5)
            );
            shouldPaginate = false;
        } else if (cuadrillaEntrega) {
            // Solo cuadrilla entrega - no necesita paginación
            console.log('🔍 Filtro solo cuadrilla entrega');
            remitosQuery = query(
                remitosCollection,
                where('idCuadrillaEntrega', '==', parseInt(cuadrillaEntrega, 10)),
                orderBy('idCuadrillaEntrega', 'asc'),
                limit(recordsPerPage * 5)
            );
            shouldPaginate = false;
        } else if (cuadrillaReceptora) {
            // Solo cuadrilla receptora - no necesita paginación
            console.log('🔍 Filtro solo cuadrilla receptora');
            remitosQuery = query(
                remitosCollection,
                where('idCuadrillaReceptora', '==', parseInt(cuadrillaReceptora, 10)),
                orderBy('idCuadrillaReceptora', 'asc'),
                limit(recordsPerPage * 5)
            );
            shouldPaginate = false;
        } else if (dateFrom && dateTo) {
            // Solo filtro por fechas - el campo `fecha` tiene formatos mixtos en Firestore (DD/MM/YYYY, YYYYMMDD, ISO),
            // así que NO se puede usar where('fecha', ...) — traemos por id desc y filtramos client-side
            console.log('🔍 Filtro solo por fechas (client-side)');
            remitosQuery = query(
                remitosCollection,
                orderBy('id', 'desc'),
                limit(recordsPerPage * 20)
            );
            shouldPaginate = false;
        } else {
            // Sin filtros - orden descendente por ID para mostrar los más recientes primero
            console.log('🔍 Sin filtros - orden descendente por ID');
            remitosQuery = query(
                remitosCollection,
                orderBy('id', 'desc'),
                limit(recordsPerPage * 5)
            );
            shouldPaginate = false;
        }

        try {
            console.log('🔍 Ejecutando consulta...');
            console.log('🔍 Query construida:', {
                collection: 'remitos',
                filters: {
                    cuadrillaEntrega: cuadrillaEntrega ? parseInt(cuadrillaEntrega, 10) : null,
                    cuadrillaReceptora: cuadrillaReceptora ? parseInt(cuadrillaReceptora, 10) : null,
                    idRemito: idRemito ? parseInt(idRemito, 10) : null,
                    dateFrom,
                    dateTo
                }
            });

            const querySnapshot = await getDocs(remitosQuery);
            console.log('🔍 Resultados obtenidos:', querySnapshot.size);

            if (!querySnapshot.empty) {
                let data = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
                console.log('🔍 Datos procesados:', data.length, 'remitos');

                // Filtro de fecha client-side — necesario porque `fecha` tiene formatos mixtos en Firestore
                if (dateFrom && dateTo) {
                    data = data.filter(remito => {
                        const fechaNorm = parseFechaToYYYYMMDD(remito.fecha);
                        return fechaNorm && fechaNorm >= dateFrom && fechaNorm <= dateTo;
                    });
                    console.log('🔍 Datos tras filtro de fecha client-side:', data.length, 'remitos');
                }

                // Ordenar por fecha descendente (más recientes primero) — independiente del orderBy de Firestore
                data.sort((a, b) => {
                    const cmp = parseFechaToYYYYMMDD(b.fecha).localeCompare(parseFechaToYYYYMMDD(a.fecha));
                    if (cmp !== 0) return cmp;
                    return parseInt(b.id, 10) - parseInt(a.id, 10);
                });

                // 🔍 Debug: Mostrar estructura de los primeros documentos
                if (data.length > 0) {
                    console.log('🔍 Primer documento ejemplo:', {
                        id: data[0].id,
                        idCuadrillaEntrega: data[0].idCuadrillaEntrega,
                        idCuadrillaReceptora: data[0].idCuadrillaReceptora,
                        cuadrillaEntrega: data[0].cuadrillaEntrega,
                        cuadrillaReceptora: data[0].cuadrillaReceptora,
                        fecha: data[0].fecha,
                        dateQuery: data[0].dateQuery
                    });
                }

                setRemitos(data);
                setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
                setShowPagination(shouldPaginate);
                setIsSearch(true);
            } else {
                console.log('🔍 No se encontraron resultados');
                console.log('🔍 Verificando si existen documentos en la colección...');

                // Debug: Consulta simple para ver si hay documentos
                const simpleQuery = query(remitosCollection, limit(5));
                const simpleSnapshot = await getDocs(simpleQuery);
                console.log('🔍 Documentos en la colección (muestra):', simpleSnapshot.size);

                if (!simpleSnapshot.empty) {
                    const sampleData = simpleSnapshot.docs.map(doc => ({
                        id: doc.data().id,
                        idCuadrillaEntrega: doc.data().idCuadrillaEntrega,
                        idCuadrillaReceptora: doc.data().idCuadrillaReceptora,
                        cuadrillaEntrega: doc.data().cuadrillaEntrega,
                        cuadrillaReceptora: doc.data().cuadrillaReceptora
                    }));
                    console.log('🔍 Estructura de documentos de muestra:', sampleData);
                }

                setRemitos([]);
                setShowPagination(false);
                setIsSearch(true);
            }
        } catch (error) {
            console.error('❌ Error en la consulta:', error);
            console.error('❌ Error completo:', error.message);
            console.error('❌ Error stack:', error.stack);
            setRemitos([]);
            setShowPagination(false);
            setIsSearch(true);
        }

        console.log('🔍 === FIN fetchRemitos ===');
    };

    useEffect(() => {
        if (!pageNumber & params.size === 0) {
            window.location.href = `?page=${1}`;
        }
        fetchTotalCount()
        fetchRemitos(pageNumber);

    }, []);

    const oldGets = () => {
        const lastId = query(ref(database, 'remitos'), orderByChild('id'), limitToLast(1));
        onValue(lastId, (snapshot) => {
            const key = snapshot.val() ? Object.keys(snapshot.val()) : 0;
            const pageQ = Math.ceil(parseInt(key, 10) / filesPage)
            setPageQuantity(pageQ)
        }, {
            onlyOnce: true
        });

        const params = new URLSearchParams(window.location.search);

        const pageNumber = params.get('page');
        setNumberPage(pageNumber)
        const cuadrillaEntrega = params.get('cuadrillaEntrega');
        const cuadrillaReceptora = params.get('cuadrillaReceptora');
        const idRemito = params.get('idRemito');

        if (cuadrillaEntrega) {
            const searchQuery = query(ref(database, 'remitos'), orderByChild('idCuadrillaEntrega'), equalTo(parseInt(cuadrillaEntrega, 10)));
            onValue(searchQuery, (snapshot) => {
                setIsSearch(true)
                if (snapshot.val()) {
                    setRemitos(Object.values(snapshot.val()))
                } else {
                    setRemitos([])
                };
            }, {
                onlyOnce: true
            });
        }
        if (cuadrillaReceptora) {
            const searchQuery = query(ref(database, 'remitos'), orderByChild('idCuadrillaReceptora'), equalTo(parseInt(cuadrillaReceptora, 10)));
            onValue(searchQuery, (snapshot) => {
                setIsSearch(true)
                if (snapshot.val()) {
                    setRemitos(Object.values(snapshot.val()))
                } else {
                    setRemitos([])
                };
            }, {
                onlyOnce: true
            });
        }
        if (idRemito) {
            const searchQuery = query(ref(database, 'remitos'), orderByChild('id'), equalTo(parseInt(idRemito, 10)));
            onValue(searchQuery, (snapshot) => {
                setIsSearch(true)
                if (snapshot.val()) {
                    setRemitos(Object.values(snapshot.val()))
                } else {
                    setRemitos([])
                };
            }, {
                onlyOnce: true
            });
        }

        setNumberPage(pageNumber)
        setPagePagination(pageNumber)

        if (!pageNumber & params.size === 0) {
            window.location.href = `?page=${1}`;
        }

        const startFileId = (filesPage * (pageNumber - 1) - 1)
        const paginationQuery =
            query(ref(database, 'remitos'),
                orderByChild('id'),
                startAfter(startFileId),
                limitToFirst(filesPage)
            );
        if (!cuadrillaEntrega && !cuadrillaReceptora && !idRemito) {
            onValue(paginationQuery, (snapshot) => {
                setRemitos(Object.values(snapshot.val()))
            }, {
                onlyOnce: true
            });
        }
    };

    const onDataChange = (items) => {
        setRemitos(items);
    }

    const handleClose = () => {
        setOpenDeleteModal(false)
    }

    // const deleteRemito = () => {
    //     remove(ref(database, 'remitos/' + remitoToDelete))
    //         .then(() => {
    //             setSnackbarInfo({ text: 'Eliminado correctamente!', type: 'success', open: true })
    //             setOpenDeleteModal(false);
    //             setTimeout(() => {
    //                 window.location.reload();
    //             }, 2500);
    //         })
    //         .catch((error) => {
    //             setOpenDeleteModal(false)
    //             setSnackbarInfo({ text: 'Ocurrió un error', type: 'error', open: true })
    //         });
    // }

    const deleteRemito = async () => {
        try {
            // Referencia al documento a eliminar en Firestore
            const docRef = doc(firestore, 'remitos', String(remitoToDelete));

            // Eliminar el documento
            await deleteDoc(docRef);

            // Mostrar mensaje de éxito
            setSnackbarInfo({ text: 'Eliminado correctamente!', type: 'success', open: true });
            setOpenDeleteModal(false);

            // Recargar la página después de 2.5 segundos (opcional)
            setTimeout(() => {
                window.location.reload();
            }, 2500);
        } catch (error) {
            // Manejar el error
            console.log('error', error);

            setOpenDeleteModal(false);
            setSnackbarInfo({ text: 'Ocurrió un error', type: 'error', open: true });
        }
    };

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarInfo({ text: '', type: '', open: false });
    };

    const searchFilter = (e) => {
        const value = e.target.value;
        setTimeout(() => {
            if (value) {
                const filter = remitos.filter(
                    (product) =>
                        product.cuadrillaEntrega.toLowerCase().match(value.toLowerCase()) ||
                        product.cuadrillaReceptora.toLowerCase().match(value.toLowerCase()) ||
                        product.id.toString().toLowerCase().match(value.toLowerCase())
                );
                setSearchTitle(value);
                setRemitoFilter(filter);
            } else {
                setSearchTitle('');
            }
        }, 500);
    }

    const onChangePage = (number) => {
        // Mantener todos los filtros actuales y solo cambiar la página
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('page', number);
        window.location.href = `?${currentParams.toString()}`;
    }

    const clearFilters = () => {
        const params = new URLSearchParams(window.location.search);
        const pageNumber = params.get('page') || 1;
        window.location.href = `?page=${pageNumber}`
    }

    // ✅ Función para obtener los filtros activos y mostrarlos como chips
    const getActiveFilters = () => {
        const filters = [];
        const cuadrillaEntrega = params.get('cuadrillaEntrega');
        const cuadrillaReceptora = params.get('cuadrillaReceptora');
        const idRemito = params.get('idRemito');
        const dateFrom = params.get('dateFrom');
        const dateTo = params.get('dateTo');

        if (cuadrillaEntrega) {
            filters.push({ key: 'cuadrillaEntrega', label: `Origen: ID ${cuadrillaEntrega}`, value: cuadrillaEntrega });
        }
        if (cuadrillaReceptora) {
            filters.push({ key: 'cuadrillaReceptora', label: `Destino: ID ${cuadrillaReceptora}`, value: cuadrillaReceptora });
        }
        if (idRemito) {
            filters.push({ key: 'idRemito', label: `Remito: ${idRemito}`, value: idRemito });
        }
        if (dateFrom && dateTo) {
            const from = formatDate(dateFrom);
            const to = formatDate(dateTo);
            filters.push({ key: 'dateRange', label: `Fecha: ${from} - ${to}`, value: `${dateFrom}-${dateTo}` });
        }

        return filters;
    }

    // ✅ Función para remover un filtro específico
    const removeFilter = (filterKey) => {
        const currentParams = new URLSearchParams(window.location.search);

        if (filterKey === 'cuadrillaEntrega') {
            currentParams.delete('cuadrillaEntrega');
        } else if (filterKey === 'cuadrillaReceptora') {
            currentParams.delete('cuadrillaReceptora');
        } else if (filterKey === 'idRemito') {
            currentParams.delete('idRemito');
        } else if (filterKey === 'dateRange') {
            currentParams.delete('dateFrom');
            currentParams.delete('dateTo');
        }

        // Mantener page=1 cuando se remueven filtros
        currentParams.set('page', '1');

        const newSearch = currentParams.toString();
        window.location.href = `?${newSearch}`;
    }

    // Función para obtener los emails de las cuadrillas origen y destino
    const getCuadrillasEmails = async (remito) => {
        try {
            console.log('🔍 Obteniendo emails de cuadrilla origen y destino para remito:', remito.id);
            const emails = [];

            // 1. Obtener email de origen (entrega)
            let emailOrigen = '';
            if (remito.emailCuadrillaEntrega && remito.emailCuadrillaEntrega.trim() !== '') {
                emailOrigen = remito.emailCuadrillaEntrega.trim();
            } else if (remito.idCuadrillaEntrega) {
                emailOrigen = await getCuadrillaEmailById(remito.idCuadrillaEntrega);
            }
            if (emailOrigen) {
                emails.push(emailOrigen);
            }

            // 2. Obtener email de destino (receptora)
            let emailDestino = '';
            if (remito.emailCuadrillaReceptora && remito.emailCuadrillaReceptora.trim() !== '') {
                emailDestino = remito.emailCuadrillaReceptora.trim();
            } else if (remito.idCuadrillaReceptora) {
                emailDestino = await getCuadrillaEmailById(remito.idCuadrillaReceptora);
            }
            if (emailDestino) {
                emails.push(emailDestino);
            }

            console.log('✅ Emails encontrados:', emails);
            return emails.join(', ');
        } catch (error) {
            console.error('❌ Error al obtener emails de cuadrillas:', error);
            return '';
        }
    };

    // Función para enviar email con template HTML (copiada de FacturaRemito)
    const sendEmailWithHTML = async (emailData, receiver, remito) => {
        try {
            console.log('📧 Preparando email con template HTML...');

            // Preparar datos para el template HTML
            const emailParams = {
                title: `${remito.tipoRemito} de Materiales #${remito.id}`,
                subject: `${remito.tipoRemito} de Materiales #${remito.id}`,
                to_name: "Cuadrilla Receptora",
                to_email: receiver,
                from_name: "CBA Construir",
                message: emailData.message,

                // Datos del remito
                tipo_remito: remito.tipoRemito,
                remito_number: remito.id,
                numero_remito_formatted: remito.id?.toString().padStart(5, '0'),
                fecha_confeccion: remito.confectionDate ? moment(remito.confectionDate, "DD/MM/YYYY HH:mm").format("DD/MM/YYYY") : '',
                cuadrilla_origen: remito.cuadrillaEntrega,
                cuadrilla_destino: remito.cuadrillaReceptora,
                fecha_entrega: formatDate(remito.fecha),
                observaciones_generales: remito.observaciones || '',

                // Convertir arrays a strings HTML para EmailJS
                controles_html: remito.controles?.map(control =>
                    `<tr>
                        <td width="14%">${control.id || ''}</td>
                        <td width="49%">Control ${(control.name || '').toUpperCase()}</td>
                        <td width="9%">${control.value || ''}</td>
                        <td width="24%">${control.observaciones || ''}</td>
                    </tr>`
                ).join('') || '',

                materials_html: remito.materials?.map(material =>
                    `<tr>
                        <td width="14%">${material.id || ''}</td>
                        <td width="49%">${material.name || ''}</td>
                        <td width="9%">${material.value || ''}</td>
                        <td width="24%">${material.observaciones || ''}</td>
                    </tr>`
                ).join('') || '',

                serials_html: remito.serials?.map((serial, index) =>
                    `<tr>
                        <td width="6%" style="text-align: center;">${index + 1}</td>
                        <td width="14%">${(serial.tipo || '').toUpperCase()}</td>
                        <td width="46%">${serial.id || ''}</td>
                        <td width="34%">${serial.observaciones || ''}</td>
                    </tr>`
                ).join('') || ''
            };

            console.log('📧 Enviando email para remito:', remito.id);

            return emailjs.send("service_dtta4bo", "template_n45n6wy", emailParams, 'G-CNczSPmMLzPKizx')
                .then((result) => {
                    console.log('✅ Email HTML enviado exitosamente:', result);
                    return result;
                })
                .catch((error) => {
                    console.error('❌ Error al enviar email HTML:', error);
                    throw error;
                });

        } catch (error) {
            console.error('❌ Error en sendEmailWithHTML:', error);
            throw error;
        }
    };

    // Función para abrir el modal de email
    const handleOpenEmailModal = async (remito) => {
        setSelectedRemito(remito);
        setOpenEmailModal(true);
        setEmailLoadingCuadrilla(true);
        setRecipientEmail('');

        // Intentar obtener el email automáticamente
        try {
            const email = await getCuadrillasEmails(remito);
            setRecipientEmail(email);
        } catch (error) {
            console.error('Error al obtener email:', error);
            setRecipientEmail('');
        } finally {
            setEmailLoadingCuadrilla(false);
        }
    };

    // Función para cerrar el modal de email
    const handleCloseEmailModal = () => {
        setOpenEmailModal(false);
        setSelectedRemito(null);
        setRecipientEmail('');
        setEmailLoading(false);
    };

    // Función para enviar el email
    const handleSendEmail = async () => {
        if (!selectedRemito) return;

        try {
            setEmailLoading(true);

            // Validar email
            if (!recipientEmail || recipientEmail.trim() === '') {
                throw new Error('Por favor ingrese un email válido');
            }

            // Validar cada correo electrónico ingresado separado por comas o punto y coma
            const emails = recipientEmail.split(/[\s,;]+/).filter(Boolean);
            if (emails.length === 0) {
                throw new Error('Por favor ingrese al menos un email válido');
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            for (const email of emails) {
                if (!emailRegex.test(email)) {
                    throw new Error(`El email "${email}" no tiene un formato válido`);
                }
            }

            // Preparar datos del email
            const emailData = {
                message: `Se adjunta ${selectedRemito.tipoRemito} de materiales desde ${selectedRemito.cuadrillaEntrega} hacia ${selectedRemito.cuadrillaReceptora}. El remito se muestra completo en este email con todos los detalles, materiales y equipos.`
            };

            // Enviar el email
            await sendEmailWithHTML(emailData, recipientEmail.trim(), selectedRemito);

            setSnackbarInfo({
                text: `Remito #${selectedRemito.id} enviado exitosamente a ${recipientEmail}`,
                type: 'success',
                open: true
            });

            handleCloseEmailModal();

        } catch (error) {
            console.error('Error al enviar remito por email:', error);
            setSnackbarInfo({
                text: `Error al enviar email: ${error.message}`,
                type: 'error',
                open: true
            });
        } finally {
            setEmailLoading(false);
        }
    };

    const normalizeFecha = parseFechaToYYYYMMDD;

    const handleDownloadDevoluciones = async () => {
        if (!downloadDateFrom || !downloadDateTo) return;
        setDownloadLoading(true);
        try {
            const desde = moment(downloadDateFrom).format("YYYYMMDD");
            const hasta = moment(downloadDateTo).format("YYYYMMDD");

            const devolucionesQuery = query(
                remitosCollection,
                where('tipoRemito', '==', 'DEVOLUCION')
            );
            const snapshot = await getDocs(devolucionesQuery);

            const remitosInRange = snapshot.docs
                .map(d => ({ ...d.data(), id: d.id }))
                .filter(r => {
                    const fechaNorm = normalizeFecha(r.fecha);
                    return fechaNorm && fechaNorm >= desde && fechaNorm <= hasta;
                });

            if (remitosInRange.length === 0) {
                setSnackbarInfo({ text: 'No se encontraron devoluciones en el rango de fechas', type: 'warning', open: true });
                return;
            }

            const fileName = `devoluciones_${desde}_${hasta}.xlsx`;
            const totalRows = await downloadDevolucionExcelMultiple(remitosInRange, fileName);

            setSnackbarInfo({
                text: `Planilla descargada: ${remitosInRange.length} remitos / ${totalRows} seriales`,
                type: 'success',
                open: true,
            });
            setOpenDownloadModal(false);
            setDownloadDateFrom(null);
            setDownloadDateTo(null);
        } catch (error) {
            console.error('Error al descargar devoluciones:', error);
            setSnackbarInfo({ text: 'Ocurrió un error al descargar la planilla', type: 'error', open: true });
        } finally {
            setDownloadLoading(false);
        }
    };

    const displayTable = searchTitle !== "" ? remitoFilter : remitos;

    const activeFilters = getActiveFilters();

    return (
        <Container component="main" maxWidth="xl">
            <h4>Listado de remitos</h4>
            <div className="filters-container">
                <Button
                    variant="contained"
                    endIcon={<SearchIcon />}
                    sx={{ marginBottom: '20px' }}
                    onClick={() => setOpenSearchModal(true)}
                >
                    Aplicar Filtros
                </Button>
                <Button
                    variant="outlined"
                    sx={{ marginLeft: '20px', marginBottom: '20px' }}
                    onClick={() => clearFilters()}
                >
                    Limpiar Filtros
                </Button>
                <Button
                    variant="contained"
                    endIcon={<FileDownloadIcon />}
                    sx={{ marginLeft: '20px', marginBottom: '20px', backgroundColor: '#1565c0', '&:hover': { backgroundColor: '#0d47a1' } }}
                    onClick={() => setOpenDownloadModal(true)}
                >
                    Descargar devoluciones
                </Button>
                <Button variant="contained" href="/remito" sx={{ marginBottom: '20px', marginLeft: 'auto' }}>Nuevo remito</Button>
            </div>

            {/* ✅ Mostrar filtros activos como chips */}
            {activeFilters.length > 0 && (
                <Box sx={{ marginBottom: 2 }}>
                    <Typography variant="body2" sx={{ marginBottom: 1, color: '#666' }}>
                        Filtros aplicados:
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {activeFilters.map((filter) => (
                            <Chip
                                key={filter.key}
                                label={filter.label}
                                onDelete={() => removeFilter(filter.key)}
                                color="primary"
                                variant="outlined"
                                size="small"
                            />
                        ))}
                    </Box>
                </Box>
            )}
            {displayTable?.length > 0 && showPagination && pageNumber &&
                <Pagination
                    count={pageQuantity}
                    page={parseInt(pageNumber, 10)}
                    className="list-pagination"
                    onChange={(e, number) => onChangePage(number)}
                    size="large"
                    sx={{ margin: '15px 0', justifyContent: 'center' }}
                />
            }
            <TableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Número</StyledTableCell>
                            <StyledTableCell>Tipo</StyledTableCell>
                            <StyledTableCell>Almacén origen</StyledTableCell>
                            <StyledTableCell>Almacén destino</StyledTableCell>
                            <StyledTableCell>Fecha</StyledTableCell>
                            <StyledTableCell>Acciones</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayTable?.length > 0 ? (
                            displayTable.map((remito, index) => (
                                <StyledTableRow
                                    key={index}
                                    sx={remitos?.deleted && { display: 'none' }}
                                >
                                    <StyledTableCell>{remito.id}</StyledTableCell>
                                    <StyledTableCell>{remito.tipoRemito}</StyledTableCell>
                                    <StyledTableCell>{remito.usuarioCuadrillaEntrega ? `${remito.usuarioCuadrillaEntrega} - ${remito.cuadrillaEntrega}` : remito.cuadrillaEntrega}</StyledTableCell>
                                    <StyledTableCell>{remito.usuarioCuadrillaReceptora ? `${remito.usuarioCuadrillaReceptora} - ${remito.cuadrillaReceptora}` : remito.cuadrillaReceptora}</StyledTableCell>
                                    <StyledTableCell>{formatDate(remito.fecha)}</StyledTableCell>
                                    {/* <StyledTableCell>{remito?.seriales && remito.seriales.map(serial => (
                                        <div>
                                            <span>{serial.tipo.toUpperCase()} : </span>
                                            <span> {serial.id}</span>
                                        </div>
                                    ))
                                    }
                                    </StyledTableCell> */}

                                    <StyledTableCell className="column-actions">
                                        <Tooltip title="Enviar por email">
                                            <IconButton
                                                aria-label="email"
                                                className="action__button"
                                                onClick={() => handleOpenEmailModal(remito)}
                                                sx={{ color: '#1976D2' }}
                                            >
                                                <ForwardToInboxIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <IconButton
                                            aria-label="print"
                                            className="action__link"
                                            href={`/imprimir/${remito.id}${window.location.search}`}
                                            role="button"
                                        >
                                            <PrintIcon />
                                        </IconButton>
                                        {remito.tipoRemito === 'DEVOLUCION' && (
                                            <Tooltip title="Descargar Excel">
                                                <IconButton
                                                    aria-label="descargar-excel"
                                                    className="action__button"
                                                    onClick={() => downloadDevolucionExcel(remito)}
                                                    sx={{ color: '#1565c0' }}
                                                >
                                                    <FileDownloadIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {currentUser?.rol === 'admin' && (
                                            <IconButton
                                                aria-label="delete"
                                                type="button"
                                                className="action__button"
                                                onClick={() => {
                                                    setOpenDeleteModal(true);
                                                    setRemitoToDelete(remito.id)
                                                }}
                                            >
                                                <DeleteIcon sx={{ color: 'red' }} />
                                            </IconButton>
                                        )}
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        ) : (
                            <StyledTableRow>
                                <StyledTableCell colSpan={13} align="center">
                                    {isSearch ? (
                                        <Typography variant="h5">
                                            No se encontraron elementos
                                        </Typography>
                                    ) : (
                                        <CircularProgress />
                                    )}
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {displayTable?.length > 0 && showPagination && pageNumber &&
                <Pagination
                    count={pageQuantity}
                    page={parseInt(pageNumber, 10)}
                    className="list-pagination"
                    onChange={(e, number) => onChangePage(number)}
                    size="large"
                    sx={{ margin: '15px 0', justifyContent: 'center' }}
                />
            }
            {openSearchModal &&
                <ModalFilters
                    open={openSearchModal}
                    onCloseModal={() => setOpenSearchModal(false)}
                    items={['cuadrillaEntrega', 'cuadrillaReceptora', 'idRemito', 'dateFrom', 'dateTo']}
                />
            }

            {/* Modal de envío de email */}
            <Dialog
                open={openEmailModal}
                onClose={handleCloseEmailModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <EmailIcon sx={{ color: '#2e7d32' }} />
                        Enviar Remito por Email
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ marginBottom: 2 }}>
                        {selectedRemito && (
                            <>
                                Enviar <strong>{selectedRemito.tipoRemito} #{selectedRemito.id}</strong>
                                <br />
                                Desde: <strong>{selectedRemito.usuarioCuadrillaEntrega ? `${selectedRemito.usuarioCuadrillaEntrega} - ${selectedRemito.cuadrillaEntrega}` : selectedRemito.cuadrillaEntrega}</strong>
                                <br />
                                Hacia: <strong>{selectedRemito.usuarioCuadrillaReceptora ? `${selectedRemito.usuarioCuadrillaReceptora} - ${selectedRemito.cuadrillaReceptora}` : selectedRemito.cuadrillaReceptora}</strong>
                            </>
                        )}
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin="dense"
                        label="Email del destinatario"
                        type="email"
                        fullWidth
                        variant="outlined"
                        value={recipientEmail}
                        onChange={(e) => setRecipientEmail(e.target.value)}
                        disabled={emailLoadingCuadrilla || emailLoading}
                        placeholder="ejemplo@email.com"
                        helperText={emailLoadingCuadrilla ? "Obteniendo email de la cuadrilla..." : "Ingrese el email donde enviar el remito"}
                        InputProps={{
                            endAdornment: emailLoadingCuadrilla && (
                                <CircularProgress size={20} />
                            )
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCloseEmailModal}
                        disabled={emailLoading}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSendEmail}
                        variant="contained"
                        disabled={emailLoading || !recipientEmail.trim()}
                        startIcon={emailLoading ? <CircularProgress size={16} /> : <SendIcon />}
                        sx={{
                            backgroundColor: '#2e7d32',
                            '&:hover': { backgroundColor: '#1b5e20' }
                        }}
                    >
                        {emailLoading ? 'Enviando...' : 'Enviar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openDownloadModal}
                onClose={() => !downloadLoading && setOpenDownloadModal(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FileDownloadIcon sx={{ color: '#1565c0' }} />
                        Descargar devoluciones por rango de fechas
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ paddingTop: '24px !important' }}>
                    <DialogContentText sx={{ marginBottom: 2 }}>
                        Se descargará un Excel con los seriales de todos los remitos de tipo DEVOLUCION cuya fecha esté en el rango seleccionado.
                    </DialogContentText>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', marginTop: 1 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Fecha desde"
                                inputFormat="DD/MM/YYYY"
                                value={downloadDateFrom}
                                onChange={(value) => setDownloadDateFrom(value)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Fecha hasta"
                                inputFormat="DD/MM/YYYY"
                                value={downloadDateTo}
                                onChange={(value) => setDownloadDateTo(value)}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </Box>
                </DialogContent>
                <DialogActions>
                    {downloadLoading && <CircularProgress size={20} sx={{ marginRight: 1 }} />}
                    <Button onClick={() => setOpenDownloadModal(false)} disabled={downloadLoading}>
                        Cerrar
                    </Button>
                    <Button
                        onClick={handleDownloadDevoluciones}
                        variant="contained"
                        disabled={downloadLoading || !downloadDateFrom || !downloadDateTo}
                        startIcon={<FileDownloadIcon />}
                        sx={{ backgroundColor: '#1565c0', '&:hover': { backgroundColor: '#0d47a1' } }}
                    >
                        {downloadLoading ? 'Descargando...' : 'Descargar'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openDeleteModal}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Desea eliminar este remito?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Los cambios serán permanentes.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cerrar</Button>
                    <Button onClick={deleteRemito} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default ListRemitos;
